<template>
	<article 
	@mousemove="mouseMove"
	@click="dropPlayer"
	class="px-2 py-2 relative bg-white border-2 border-b-4 rounded-lg border-black aspect-[9/12] flex flex-col">
		<div class="flex gap-4 items-center">
			<div><img src="/img/escudo-universitario.png" alt="" class="h-10 w-10"></div>
			<div>
				<h2 class="font-bold text-2xl">{{ name }}</h2>
				<div class="font-bold text-gray-500 text-xs leading-none">{{  byline }}</div>
			</div>
		</div>

		<!-- Votes -->
		<div class="bg-pink-50 border-2 border-b-4 border-black rounded-e-md absolute -left-0.5 top-20 pl-2 pr-2">
			<div class="">
				<div class="text-pink-800 font-semibold text-center mt-1">
					{{ votes }} 
				</div>
				<div class="text-gray-500 text-xs mb-1 hover:text-pink-800">
					<!-- Heart icon -->
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8">
  						<path d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
					</svg>
				</div>
			</div>
		</div>

		<!-- Shuffles -->
		<div class="bg-pink-800 border-2 border-b-4 border-black rounded-s-md absolute -right-0.5 top-20 pl-2 pr-2">
			<div class="">
				<div class="text-pink-200 font-semibold text-center mt-1">
					{{ shuffles }} 
				</div>
				<div class="text-pink-100 text-xs mb-1 hover:text-white">
					<!-- Arrow path rounded square icon -->
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-8 mx-auto">
  						<path fill-rule="evenodd" d="M12 5.25c1.213 0 2.415.046 3.605.135a3.256 3.256 0 0 1 3.01 3.01c.044.583.077 1.17.1 1.759L17.03 8.47a.75.75 0 1 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 0 0-1.06-1.06l-1.752 1.751c-.023-.65-.06-1.296-.108-1.939a4.756 4.756 0 0 0-4.392-4.392 49.422 49.422 0 0 0-7.436 0A4.756 4.756 0 0 0 3.89 8.282c-.017.224-.033.447-.046.672a.75.75 0 1 0 1.497.092c.013-.217.028-.434.044-.651a3.256 3.256 0 0 1 3.01-3.01c1.19-.09 2.392-.135 3.605-.135Zm-6.97 6.22a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06l1.752-1.751c.023.65.06 1.296.108 1.939a4.756 4.756 0 0 0 4.392 4.392 49.413 49.413 0 0 0 7.436 0 4.756 4.756 0 0 0 4.392-4.392c.017-.223.032-.447.046-.672a.75.75 0 0 0-1.497-.092c-.013.217-.028.434-.044.651a3.256 3.256 0 0 1-3.01 3.01 47.953 47.953 0 0 1-7.21 0 3.256 3.256 0 0 1-3.01-3.01 47.759 47.759 0 0 1-.1-1.759L6.97 15.53a.75.75 0 0 0 1.06-1.06l-3-3Z" clip-rule="evenodd" />
					</svg>
				</div>
			</div>

		</div>

		<div class="absolute right-2 bottom-3 pl-2 pr-2">
			<div class="text-pink-800/50 text-xs font-bold">#{{ id }}</div>
		</div>

		<team-player class="border-4 border-dashed" :class="(activePlayer && activePlayer.id == p.id) ? 'border-red-900': 'border-transparent'" @click="activatePlayer($event, p)" v-for="(p, i) in players" :key="p.id" :player="p" :left="p.x" :top="p.y" />

		<!-- Field -->
		<img id="field" src="/img/field.png" alt="" class="mt-2 w-full grow"  @click="$emit('selected', null)">

		<!-- Watermark -->
		<div class="absolute left-2 bottom-3 pl-2 pr-2">
			<img src="/img/logo.png" alt="" class="h-8 grayscale opacity-25">
		</div>
	</article>
</template>
<script lang="ts">

import TeamPlayer from './team-player.vue';
import { Player } from '../types';

export default {
	components: {
		TeamPlayer,
	},
  props: {
    players: {
      type: Array as () => Player[],
      required: true,
    },
	 activePlayer: {
		 type: Object as () => Player,
		 required: false,
	 },
  },
  data() {
    return {
		name: "El Tri-5-2",
		id: "ABC123",
		byline: "@freezy",
		votes: 10,
		shuffles: 2456,
    };
  },
  mounted() {
  },
  methods: {
	mouseMove(e: MouseEvent) {
		return;
		if (this.activePlayer) {
			const field  = document.getElementById('field');
			const rect = field.getBoundingClientRect();
			this.activePlayer.x = (e.clientX - rect.left) / rect.width * 100;
			this.activePlayer.y = (e.clientY - rect.top) / rect.height * 100;
		}
	},
	activatePlayer(evt: Event, player: Player) {
		evt.stopPropagation();
		if (this.activePlayer && this.activePlayer.id === player.id) {
			this.dropPlayer();
		} else {
			this.$emit('selected', player);
		}
	},
		dropPlayer() {
			if (this.activePlayer) {
				this.$emit('selected', null);
			}
		}
  },
  computed: {
  },
};
</script>


<style scoped></style>
